<div class="progress-container">
  <div class="progress-bar in-service-bar" [ngStyle]="{ 'width': inServicePercentage + '%' }">
    <strong>{{inService}} </strong> In Service
  </div>
  <div class="progress-bar pending-bar" [ngStyle]="{ 'width': pendingPercentage + '%' }">
    <strong>{{pending}} </strong> Pending
  </div>
</div>